export const extractPartNumberFather = (partNumber: string | undefined) => {
	if (!partNumber) return partNumber;
	return partNumber.includes('-T') ? partNumber.split('-T')[0] : partNumber;
};
